import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {InputSwitch} from "primereact/inputswitch";
import {BlockUI} from "primereact/blockui";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";
import {Dropdown} from "primereact/dropdown";
import {Badge} from "primereact/badge";
import {Password} from "primereact/password";

const OperatorFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [locking, setLocking] = useState(false);
  const [billingIntegrations, setBillingIntegrations] = useState([]);
  const [paycenter, setPaycenter] = useState({});
  const [paycenterConnect, setPaycenterConnect] = useState({});


  const validate = (data) => {
    let errors = {};
    if (!data.company_name) {
      errors.company_name = t('required_field');
    }
    if (!data.tax_number) {
      errors.tax_number = t('required_field');
    }
    if (!data.zip_code) {
      errors.zip_code = t('required_field');
    }
    if (!data.registered_office_city) {
      errors.registered_office_city = t('required_field');
    }
    if (!data.street_and_house_number) {
      errors.street_and_house_number = t('required_field');
    }
    if (!data.billing_integration) {
      errors.billing_integration = t('required_field');
    }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "operator-data/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderOperatorList: Math.random(),
            selectedOperatorId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "operator-data",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderOperatorList: Math.random(),
            selectedOperatorId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    //form.restart();
  };
  //const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  //const isFormFieldValid = (meta) => !!(meta.error);
  const isFormFieldValid = (meta) => {
    if (loading) return false;
    return !!(meta.error);
  };
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-validate">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/billing-integration",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setBillingIntegrations(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setLoading(false)
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "integration/paycenter",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setPaycenter(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "operator-data/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }, [window.App.state.rerenderOperatorForm])

  useEffect(() => {
    if (!billingIntegrations[0] || formData.billing_integration) return;
    const defaultBillingIntegration = billingIntegrations[0].value;
    setFormData((prev) => ({
      ...prev,
      billing_integration: defaultBillingIntegration
    }));
    setNewFormData((prev) => ({
      ...prev,
      billing_integration: defaultBillingIntegration
    }));
  }, [billingIntegrations, formData.billing_integration]);

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit, form}) => (
          <form
            onSubmit={(event) => {
              const submitResult = handleSubmit(event);
              const formState = form.getState();
              if (formState.submitFailed && (formState.hasValidationErrors || formState.invalid)) {
                window.App.toastShow('warn', t('warning'), t('reservation_submit_required_fields_invalid'));
              }
              return submitResult;
            }}
            className=""
          >
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('operator_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  {window.location.href.includes('#/operator') &&
                    <Button type="submit" aria-label={t('save_and_close')}
                            loading={loading}
                            onClick={() => {
                              props = {...props, closeForm: true}
                            }}
                            className="p-button-success p-ml-2">
                    <span>
                      <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                    </span>
                    </Button>
                  }
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <Field name="company_name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"company_name"}/>
                      <label htmlFor="company_name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('company_name')}</label>
                      <span className="p-d-block">
                      <InputText id="company_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     company_name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     company_name: e.target.value
                                   })
                                 }}
                                 value={formData.company_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <Field name="tax_number" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"tax_number"}/>
                      <label htmlFor="tax_number"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('tax_number')}</label>
                      <span className="p-d-block">
                      <InputText id="tax_number" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     tax_number: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     tax_number: e.target.value
                                   })
                                 }}
                                 value={formData.tax_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-2 p-xl-2"}>
                  <Field name="zip_code" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"zip_code"}/>
                      <label htmlFor="zip_code"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('zip_code')}</label>
                      <span className="p-d-block">
                      <InputText id="zip_code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     zip_code: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     zip_code: e.target.value
                                   })
                                   if (e.target.value.length >= 4) {
                                     window.App.zipCode(e.target.value, (city) => {
                                       setFormData(prev => ({
                                         ...prev,
                                         registered_office_city: city
                                       }));
                                     });
                                   }
                                 }}
                                 value={formData.zip_code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4 p-xl-4"}>
                  <Field name="registered_office_city" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"registered_office_city"}/>
                      <label htmlFor="registered_office_city"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('registered_office_city')}</label>
                      <span className="p-d-block">
                      <InputText id="registered_office_city" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     registered_office_city: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     registered_office_city: e.target.value
                                   })
                                 }}
                                 value={formData.registered_office_city}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <Field name="street_and_house_number" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"street_and_house_number"}/>
                      <label htmlFor="street_and_house_number"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('street_and_house_number')}</label>
                      <span className="p-d-block">
                      <InputText id="street_and_house_number" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     street_and_house_number: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     street_and_house_number: e.target.value
                                   })
                                 }}
                                 value={formData.street_and_house_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="bank_name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"bank_name"}/>
                      <label htmlFor="bank_name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('bank_name')}</label>
                      <span className="p-d-block">
                      <InputText id="bank_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     bank_name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     bank_name: e.target.value
                                   })
                                 }}
                                 value={formData.bank_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-8"}>
                  <Field name="bank_account_number" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"bank_account_number"}/>
                      <label htmlFor="bank_account_number"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('bank_account_number')}</label>
                      <span className="p-d-block">
                      <InputText id="bank_account_number" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     bank_account_number: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     bank_account_number: e.target.value
                                   })
                                 }}
                                 value={formData.bank_account_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="contact_email" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"contact_email"}/>
                      <label htmlFor="contact_email"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_email')}</label>
                      <span className="p-d-block">
                      <InputText id="contact_email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     contact_email: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     contact_email: e.target.value
                                   })
                                 }}
                                 value={formData.contact_email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <Field name="vat_payment" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"vat_payment"}/>
                      <label htmlFor="vat_payment"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('vat_payment')}</label>
                      <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-2"}
                        checked={formData.vat_payment}
                        value={formData.vat_payment}
                        onChange={e => {
                          setFormData({...formData, vat_payment: e.target.value})
                          setNewFormData({...newFormData, vat_payment: e.target.value})
                        }}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
            <Panel className={"p-mt-3"}>
              <h3 className={"p-mt-0"}>{t('billing_integration')}</h3>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="billing_integration" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"billing_integration"}/>
                      <label htmlFor="billing_integration"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('billing_integration_name')}</label>
                      <span className="p-d-block">
                        <Dropdown  options={billingIntegrations}
                                  optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                  optionValue="value"
                                  id={"billing_integration"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      billing_integration: e.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      billing_integration: e.value
                                    })
                                  }}
                                  value={formData.billing_integration}
                        />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {formData.billing_integration === 'számlázz.hu' &&
                  <>
                    <div className={"p-col-12 p-lg-12"}>
                      <Field name="szamlazz_hu_agent_code" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <HelpComponent type={"field"} field={"szamlazz_hu_agent_code"}/>
                          <label htmlFor="szamlazz_hu_agent_code"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{t('szamlazz_hu_agent_code')}</label>
                          <span className="p-d-block">
                      <InputText id="szamlazz_hu_agent_code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     szamlazz_hu_agent_code: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     szamlazz_hu_agent_code: e.target.value
                                   })
                                 }}
                                 value={formData.szamlazz_hu_agent_code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}/>
                    </div>
                  </>
                }
                {formData.billing_integration === 'Billingo' &&
                  <>
                    <div className={"p-col-12 p-lg-8"}>
                      <Field name="billingo_api_key" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <HelpComponent type={"field"} field={"billingo_api_key"}/>
                          <label htmlFor="billingo_api_key"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{t('billingo_api_key')}</label>
                          <span className="p-d-block">
                      <InputText id="billingo_api_key" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     billingo_api_key: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     billingo_api_key: e.target.value
                                   })
                                 }}
                                 value={formData.billingo_api_key}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}/>
                    </div>
                    <div className={"p-col-12 p-lg-4"}>
                      <Field name="billingo_block_id" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <HelpComponent type={"field"} field={"billingo_block_id"}/>
                          <label htmlFor="billingo_block_id"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{t('billingo_block_id')}</label>
                          <span className="p-d-block">
                      <InputText id="billingo_block_id" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     billingo_block_id: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     billingo_block_id: e.target.value
                                   })
                                 }}
                                 value={formData.billingo_block_id}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}/>
                    </div>
                    <div className={"p-col-12 p-lg-4"}>
                      <Field name="billingo_bank_account_id" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <HelpComponent type={"field"} field={"billingo_bank_account_id"}/>
                          <label htmlFor="billingo_bank_account_id"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{t('billingo_bank_account_id')}</label>
                          <span className="p-d-block">
                      <InputText id="billingo_bank_account_id" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     billingo_bank_account_id: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     billingo_bank_account_id: e.target.value
                                   })
                                 }}
                                 value={formData.billingo_bank_account_id}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}/>
                    </div>
                  </>
                }
              </div>
            </Panel>
            {/*<Panel className={"p-mt-3"}>*/}
            {/*  <h3 className={"p-mt-0"}>*/}
            {/*    {t('paycenter_integration')}*/}
            {/*    <Badge*/}
            {/*      value={t(paycenter.status)}*/}
            {/*      style={{*/}
            {/*        marginLeft: '10px',*/}
            {/*        position: 'relative',*/}
            {/*        top: '-1px'*/}
            {/*      }}*/}
            {/*    />*/}
            {/*  </h3>*/}
            {/*  {(paycenter.status === 'not_connected' || paycenter.status === 'link_error') &&*/}
            {/*    <>*/}
            {/*      <div className={"p-grid"}>*/}
            {/*        <div className={"p-col-12 p-lg-6"}>*/}
            {/*          <div className="p-field p-fluid">*/}
            {/*            <HelpComponent type={"field"} field={"paycenter_email"}/>*/}
            {/*            <label htmlFor="paycenter_email">{t('paycenter_email')}</label>*/}
            {/*            <span className="p-d-block">*/}
            {/*              <InputText id="paycenter_email"*/}
            {/*                         onChange={(e) => {*/}
            {/*                           setPaycenterConnect({*/}
            {/*                             ...paycenterConnect,*/}
            {/*                             paycenter_email: e.target.value*/}
            {/*                           })*/}
            {/*                         }}*/}
            {/*                         value={paycenterConnect.paycenter_email}/>*/}
            {/*            </span>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*        <div className={"p-col-12 p-lg-6"}>*/}
            {/*          <div className="p-field p-fluid">*/}
            {/*            <HelpComponent type={"field"} field={"paycenter_password"}/>*/}
            {/*            <label htmlFor="paycenter_password">{t('paycenter_password')}</label>*/}
            {/*            <span className="p-d-block">*/}
            {/*              <Password id="paycenter_password"*/}
            {/*                        onChange={(e) => {*/}
            {/*                          setPaycenterConnect({*/}
            {/*                            ...paycenterConnect,*/}
            {/*                            paycenter_password: e.target.value*/}
            {/*                          })*/}
            {/*                        }}*/}
            {/*                        value={paycenterConnect.paycenter_password}/>*/}
            {/*            </span>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*      <div className={"p-grid"}>*/}
            {/*        <div className={"p-col-12 p-text-right p-col-align-center"}>*/}
            {/*          <Button type="button" label={t('save')}*/}
            {/*                  icon={"pi pi-save"}*/}
            {/*                  loading={loading}*/}
            {/*                  onClick={() => {*/}
            {/*                    setLoading(true)*/}
            {/*                    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "integration/paycenter/link",*/}
            {/*                      paycenterConnect,*/}
            {/*                      {*/}
            {/*                        params: {},*/}
            {/*                        headers: {*/}
            {/*                          'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
            {/*                          "Sys-name": Cookies.get("instanceId"),*/}
            {/*                          "Preferred-locale": Cookies.get("language")*/}
            {/*                        }*/}
            {/*                      })*/}
            {/*                      .then(response => {*/}
            {/*                        setLoading(false)*/}
            {/*                        window.App.toastShow('success', t('success'), response.data.message)*/}
            {/*                        window.App.setState({*/}
            {/*                          rerenderOperatorForm: Math.random(),*/}
            {/*                        })*/}
            {/*                      })*/}
            {/*                      .catch(error => {*/}
            {/*                        setLoading(false)*/}
            {/*                        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)*/}
            {/*                      })*/}
            {/*                  }}*/}
            {/*                  className="p-button-success p-ml-2">*/}
            {/*          </Button>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </>*/}
            {/*  }*/}
            {/*  {paycenter.status === 'connected' &&*/}
            {/*    <>*/}
            {/*      <div className={"p-grid"}>*/}
            {/*        <div className={"p-col-12 p-lg-4"}>*/}
            {/*          <div className="p-field p-fluid">*/}
            {/*            <HelpComponent type={"field"} field={"paycenter_link_id"}/>*/}
            {/*            <label htmlFor="paycenter_link_id">{t('paycenter_link_id')}</label>*/}
            {/*            <span className="p-d-block">*/}
            {/*              <span className="p-d-block fake-input">*/}
            {/*                {paycenter.paycenter_link_id}*/}
            {/*              </span>*/}
            {/*            </span>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*        <div className={"p-col-12 p-lg-4"}>*/}
            {/*          <div className="p-field p-fluid">*/}
            {/*            <HelpComponent type={"field"} field={"paycenter_user_registration_id"}/>*/}
            {/*            <label htmlFor="paycenter_user_registration_id">{t('paycenter_user_registration_id')}</label>*/}
            {/*            <span className="p-d-block">*/}
            {/*              <span className="p-d-block fake-input">*/}
            {/*                {paycenter.paycenter_user_registration_id}*/}
            {/*              </span>*/}
            {/*            </span>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*        <div className={"p-col-12 p-lg-4"}>*/}
            {/*          <div className="p-field p-fluid">*/}
            {/*            <HelpComponent type={"field"} field={"paycenter_system_name_slugged"}/>*/}
            {/*            <label htmlFor="paycenter_system_name_slugged">{t('paycenter_system_name_slugged')}</label>*/}
            {/*            <span className="p-d-block">*/}
            {/*              <span className="p-d-block fake-input">*/}
            {/*                {paycenter.paycenter_system_name_slugged}*/}
            {/*              </span>*/}
            {/*            </span>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*      <div className={"p-grid"}>*/}
            {/*        <div className={"p-col-12 p-text-right p-col-align-center"}>*/}
            {/*          <Button type="button" label={t('disconnect')}*/}
            {/*                  icon={"pi pi-times"}*/}
            {/*                  loading={loading}*/}
            {/*                  onClick={() => {*/}
            {/*                    setLoading(true)*/}
            {/*                    axios.delete(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "integration/paycenter/link",*/}
            {/*                      {*/}
            {/*                        params: {},*/}
            {/*                        headers: {*/}
            {/*                          'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
            {/*                          "Sys-name": Cookies.get("instanceId"),*/}
            {/*                          "Preferred-locale": Cookies.get("language")*/}
            {/*                        }*/}
            {/*                      })*/}
            {/*                      .then(response => {*/}
            {/*                        setLoading(false)*/}
            {/*                        window.App.toastShow('success', t('success'), response.data.message)*/}
            {/*                        window.App.setState({*/}
            {/*                          rerenderOperatorForm: Math.random(),*/}
            {/*                        })*/}
            {/*                      })*/}
            {/*                      .catch(error => {*/}
            {/*                        setLoading(false)*/}
            {/*                        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)*/}
            {/*                      })*/}
            {/*                  }}*/}
            {/*                  className="p-button-danger p-ml-2">*/}
            {/*          </Button>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </>*/}
            {/*  }*/}
            {/*  {paycenter.status === 'retryable' &&*/}
            {/*    <>*/}
            {/*      <div className={"p-grid"}>*/}
            {/*        <div className={"p-col-12 p-text-right p-col-align-center"}>*/}
            {/*          <Button type="button" label={t('disconnect')}*/}
            {/*                  icon={"pi pi-times"}*/}
            {/*                  loading={loading}*/}
            {/*                  onClick={() => {*/}
            {/*                    setLoading(true)*/}
            {/*                    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "integration/paycenter/link/retry",*/}
            {/*                      {},*/}
            {/*                      {*/}
            {/*                        params: {},*/}
            {/*                        headers: {*/}
            {/*                          'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
            {/*                          "Sys-name": Cookies.get("instanceId"),*/}
            {/*                          "Preferred-locale": Cookies.get("language")*/}
            {/*                        }*/}
            {/*                      })*/}
            {/*                      .then(response => {*/}
            {/*                        setLoading(false)*/}
            {/*                        window.App.toastShow('success', t('success'), response.data.message)*/}
            {/*                        window.App.setState({*/}
            {/*                          rerenderOperatorForm: Math.random(),*/}
            {/*                        })*/}
            {/*                      })*/}
            {/*                      .catch(error => {*/}
            {/*                        setLoading(false)*/}
            {/*                        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)*/}
            {/*                      })*/}
            {/*                  }}*/}
            {/*                  className="p-button-danger p-ml-2">*/}
            {/*          </Button>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </>*/}
            {/*  }*/}
            {/*</Panel>*/}
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(OperatorFormComponent);
